<template>
    <div ref="wrapper">
        <slot></slot>
    </div>
</template>

<script>
import * as util from '../../../../utilities/utilities';

export default {
    mounted() {
        const delay = this.$parent.delay ? this.$parent.delay : '0.24';

        util.addAnimations(
            [
                greensock.fromTo(
                    this.$refs.wrapper,
                    {
                        opacity: 0,
                        y: '32'
                    },
                    {
                        opacity: 1,
                        y: '0',
                        duration: 0.8,
                        delay: delay,
                        ease: 'power3.out'
                    }
                )
            ],
            this.$refs.wrapper,
            '',
            -this.$parent.windowHalfY + 100,
            '',
            this.$parent.scrollcontrol,
            this.$parent.repeat
        );
    }
};
</script>
